import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { MailService } from 'src/app/services/mail/mail.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private mailService: MailService
  ) {}

  ngOnInit() {}

  allshops() {
    this.router.navigate(['all-shops']);
  }
  home() {
    this.router.navigate(['home/landing']);
  }

  about() {
    this.router.navigate(['home/about']);
  }

  track() {
    this.router.navigate(['track-order']);
  }

  cart() {
    this.router.navigate(['home/cart']);
  }

  login() {
    this.router.navigate(['home/login']);
  }
}
